module.exports = __webpack_public_path__ + "img/product4.e7af7bdc.png";